module.exports = __webpack_public_path__ + "img/need-help.77456588.png";